module.exports = __webpack_public_path__ + "bed.jpg?fc81cf5e948633fd3ed0d46d41942cb9";